import { render, staticRenderFns } from "./vueGoodWizard2.vue?vue&type=template&id=1a4c23f9&scoped=true"
import script from "./vueGoodWizard2.vue?vue&type=script&lang=js"
export * from "./vueGoodWizard2.vue?vue&type=script&lang=js"
import style0 from "./vueGoodWizard2.vue?vue&type=style&index=0&id=1a4c23f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c23f9",
  null
  
)

export default component.exports